import { Theme } from '@logto/schemas';

import styles from './LumeniaBrandPanel.module.scss';

type Props = {
  readonly theme: Theme;
};

/**
 * 品牌栏：只有三件东西——lockup、一句产品定位、一条画作。
 *
 * **零可聚焦元素**：pending / 回跳过渡两态要求整屏可聚焦元素为 0，常驻品牌栏
 * 一旦放链接就会破坏这条（冻结原型 scheme-b-split.html 同款约束）。
 *
 * 画作用背景图承载（不是 <img>）：天然不进朗读流、不占 tab 序，也不需要 alt。
 * 它的暗色处理钉在本组件自己的 data-lumenia-theme 上，不依赖祖先选择器——
 * 同一元素上有多个 token 域时钉组合选择器，是仓内既有的级联守则。
 *
 * 文案当前只出简体中文（写死）。多语种由 G1-R 第 8 项拍板后再接 i18n；
 * 本阶段**不新增 phrases**（phrases 包不可改）。
 */
const LumeniaBrandPanel = ({ theme }: Props) => (
  <aside className={styles.panel} data-lumenia-theme={theme}>
    <span className={styles.wordmark}>
      <span className={styles.logo} />
      <strong>Lumenia</strong>
    </span>
    {/* 产品自己的首屏标题，不为登录页另写营销文案。
        断在逗号处是有意的：CJK 可以在任意字间断行，放任它断会把词拆开。
        窄屏收成顶条时这个 <br> 由 CSS 关掉。 */}
    <p className={styles.line}>
      AI 的回答，
      <br />
      留在你正在读的那几行里
    </p>
    <div className={styles.art} />
  </aside>
);

export default LumeniaBrandPanel;
